import * as constants from '../constants';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCarouselData.try: {
            return true;
        }

        case constants.getCarouselData.success:
        case constants.getCarouselData.error: {
            return false;
        }

        default:
            return state;
    }
}